import React, { useEffect, useMemo } from 'react';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MainRouter from './routers/mainRouter/main-router';
import configureStore from './stores/redux/configureStore';
import './i18n';
import { StoreActionType } from './stores/redux/types';

export const App = () => {
    const store = useMemo(() => configureStore(), []);

    useEffect(() => {
        const checkOperator = localStorage.getItem('checkOperator');
        if (checkOperator) {
            try {
                store.dispatch({
                    type: StoreActionType.SET_CHECK_OPERATOR_INFO,
                    info: JSON.parse(checkOperator),
                });
            } catch {
                // ignore invalid cached operator info
            }
        }

        // ülkeler bu tarihten itibaren redux tan okunmalı
        store.dispatch({
            type: StoreActionType.SET_LAST_REGION,
            payload: {
                setLastRegion: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryId,
            },
        });
    }, [store]);

    return (
        <Provider store={store}>
            <DndProvider backend={HTML5Backend}>
                <section className="container">
                    <MainRouter />
                </section>
            </DndProvider>
        </Provider>
    );
};
